import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
var pdfViewerClassName = 'pdfViewer';

// Styles are partially copied from https://github.com/mozilla/pdfjs-dist/blob/v2.9.359/web/pdf_viewer.css
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
var globalStyles = css(_defineProperty({}, ".".concat(pdfViewerClassName), {
  marginTop: "var(--ds-space-800, 64px)",
  marginBottom: "var(--ds-space-800, 64px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.page': {
    margin: "1px auto ".concat("var(--ds-space-negative-100, -8px)", " auto"),
    border: '9px solid transparent',
    position: 'relative'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.canvasWrapper': {
    overflow: 'hidden'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.textLayer': _defineProperty({
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    opacity: 0.2
  }, 'lineHeight', 1),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.textLayer span, .textLayer br': {
    color: 'transparent',
    position: 'absolute',
    whiteSpace: 'pre',
    cursor: 'text',
    transformOrigin: '0% 0%'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '.textLayer ::-moz-selection': {
    background: 'rgba(0, 0, 255, 1)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.textLayer ::selection': {
    background: 'rgba(0, 0, 255, 1)'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.annotationLayer section': {
    position: 'absolute',
    textAlign: 'initial'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.annotationLayer .linkAnnotation > a, .annotationLayer .buttonWidgetAnnotation.pushButton > a': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.annotationLayer .linkAnnotation > a:hover, .annotationLayer .buttonWidgetAnnotation.pushButton > a:hover': {
    opacity: 0.2,
    background: 'rgba(255, 255, 0, 1)',
    boxShadow: '0 2px 10px rgba(255, 255, 0, 1)'
  }
}));
export var PDFRendererWrapper = function PDFRendererWrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: globalStyles
  }, children);
};